export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11533.16a2164e.jpg";